import { ExclamationTriangleIcon } from '@radix-ui/react-icons'
import { Trans } from 'react-i18next'

export const MaintenanceAlert = () => {
  return (
    <div className="border-amber-200 border-b bg-amber-50 text-amber-900">
      <div className="container inline-flex items-center justify-center gap-2 py-2 text-sm">
        <ExclamationTriangleIcon className="w-4 flex-shrink-0" />
        <span className="wrap-break-word break-keep">
          <Trans i18nKey="maintenance-alert-202511" />
        </span>
      </div>
    </div>
  )
}
